import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react';

/**
 * The upstream wizard's buttons in French (`scaffolderReactTranslationRef`,
 * plugin-scaffolder-react 2.1, `stepper.*` keys — dist/translation.esm.js),
 * for every template still rendered by upstream's `Stepper`: all but
 * `odoo-project`, which has its own wizard (components/odooProjectWizard). A
 * template's `presentation.buttonLabels` still win over these, as upstream
 * reads them first.
 *
 * Only the stepper: `@waadoo/backstage-i18n` does not translate this ref
 * (its scaffolder entry is `scaffolderTranslationRef`), and these labels sit
 * on the « Créer » pages this app reshapes. Not `full`: every other key of
 * the ref keeps its English default.
 */
export const scaffolderReactFrTranslation = TranslationBlueprint.make({
  name: 'scaffolder-react-fr',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderReactTranslationRef,
      messages: {
        'stepper.backButtonText': 'Précédent',
        'stepper.nextButtonText': 'Suivant',
        'stepper.reviewButtonText': 'Vérifier',
        'stepper.createButtonText': 'Créer',
        'stepper.stepIndexLabel': 'Étape {{index, number}}',
      },
    }),
  },
});

// On the `app` plugin, like every TranslationBlueprint here: an extension of
// that kind created under any other pluginId is ignored without a word — see
// components/projectEnvironments/plugin.tsx. Registered in packages/app/src/App.tsx.
export const scaffolderReactTranslationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scaffolderReactFrTranslation],
});
